"use client";

import React, { useState } from "react";
import { parserHtml } from "@/utils/utils";

import ImageConstant from "@/common/constants/image";

import Image from "@/components/ui/Image";
import ChevronDownIcon from "@/components/icons/ChevronDownIcon";

type Props = {
  imgUrl?: string;
  content?: string;
  contentCenter?: boolean;
};

const BannerCollection = ({
  imgUrl,
  content,
  contentCenter = false,
}: Props) => {
  const [show, setShow] = useState<boolean>(false);
  return (
    <div className="max-w-[2500px] mx-auto">
      {imgUrl && (
        <Image
          alt="img"
          width={1440}
          height={610}
          layout="responsive"
          src={imgUrl}
          objectFit={"cover"}
          objectPosition={"center"}
          placeholder={"blur"}
          blurDataURL={ImageConstant.BlurDataURL}
        />
      )}
      {content && (
        <div className="flex flex-col justify-center items-center leading-[24px] text-sm md:text-base">
          <div
            className={`w-full px-4 md:px-0 md:max-w-[805px] mx-auto mt-6 overflow-hidden ${
              show ? "h-full" : "h-[40px] pb-[50px]"
            } `}
          >
            <p
              className={`text-base text-gray-500 ${
                contentCenter && "text-center"
              }`}
              dangerouslySetInnerHTML={{ __html: parserHtml(content) }}
            ></p>
          </div>
          {content.length > 300 && (
            <div
              className={`w-full flex justify-center items-end ${
                show ? "h-[38px]" : "mt-[-20px] h-[50px]"
              } mb-6 bg-gradient-to-b from-[#ffffff66] to-white`}
            >
              <span onClick={() => setShow(!show)}>
                <ChevronDownIcon
                  className={`${
                    show && "rotate-180"
                  } w-[18px] h-[18px] min-w-[18px] cursor-pointer`}
                />
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default BannerCollection;
